import { ScrollView, Vec2 } from 'cc';

declare module 'cc' {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    interface ScrollView {
        isScrollToBottom: boolean;
        isScrollToTop: boolean;
        isScrollToLeft: boolean;
        isScrollToRight: boolean;
        scrollPercentage: Vec2;
        canScroll: boolean;
    }
}

const SCROLL_OFFSET_TOLERANCE = 0.1;

Object.defineProperty(ScrollView.prototype, 'isScrollToBottom', {
    get(this: ScrollView) {
        // if max scroll offset is 0, it means the scroll view is not scrollable
        if (!this.getMaxScrollOffset().y) {
            return true;
        }
        return Math.abs(this.getScrollOffset().y - this.getMaxScrollOffset().y) < SCROLL_OFFSET_TOLERANCE;
    },
    configurable: true,
});
Object.defineProperty(ScrollView.prototype, 'isScrollToTop', {
    get(this: ScrollView) {
        // if max scroll offset is 0, it means the scroll view is not scrollable
        if (!this.getMaxScrollOffset().y) {
            return true;
        }
        return Math.abs(this.getScrollOffset().y) < SCROLL_OFFSET_TOLERANCE;
    },
    configurable: true,
});
Object.defineProperty(ScrollView.prototype, 'isScrollToLeft', {
    get(this: ScrollView) {
        // if max scroll offset is 0, it means the scroll view is not scrollable
        if (!this.getMaxScrollOffset().x) {
            return true;
        }
        return Math.abs(this.getScrollOffset().x) < SCROLL_OFFSET_TOLERANCE;
    },
    configurable: true,
});
Object.defineProperty(ScrollView.prototype, 'isScrollToRight', {
    get(this: ScrollView) {
        // if max scroll offset is 0, it means the scroll view is not scrollable
        if (!this.getMaxScrollOffset().x) {
            return true;
        }
        return Math.abs(-this.getScrollOffset().x - this.getMaxScrollOffset().x) < SCROLL_OFFSET_TOLERANCE;
    },
    configurable: true,
});
Object.defineProperty(ScrollView.prototype, 'canScroll', {
    get(this: ScrollView) {
        return !this.getMaxScrollOffset().equals(Vec2.ZERO);
    },
    configurable: true,
});
Object.defineProperty(ScrollView.prototype, 'scrollPercentage', {
    get(this: ScrollView) {
        const maxOffset = this.getMaxScrollOffset();
        if (maxOffset.equals(Vec2.ZERO)) {
            return Vec2.ZERO;
        }
        const offset = this.getScrollOffset();
        return new Vec2(maxOffset.x ? -offset.x / maxOffset.x : 0, maxOffset.y ? offset.y / maxOffset.y : 0);
    },
    configurable: true,
});
